/** The rules that depend on how many people play, as the server's boards apply them. */

export type TrackSlot = {
  /** Short name shown on the tile. */
  title: string;
  /** One sentence on what happens. */
  text: string;
  /** True for a slot that gives the President no power. */
  none?: boolean;
};

export type TableRules = {
  liberals: number;
  /** Fascists, not counting Hitler. */
  fascists: number;
  hitlerKnowsFascists: boolean;
  /** The six slots of the Fascist track, in order. */
  track: TrackSlot[];
};

const NONE: TrackSlot = { title: "No power", text: "Nothing happens.", none: true };
const INVESTIGATE: TrackSlot = { title: "Investigate", text: "The President learns one player's party." };
const SPECIAL: TrackSlot = { title: "Special election", text: "The President picks the next President." };
const PEEK: TrackSlot = { title: "Peek", text: "The President sees the top three policies." };
const EXECUTE: TrackSlot = { title: "Execution", text: "The President executes a player." };
const EXECUTE_VETO: TrackSlot = {
  title: "Execution + veto",
  text: "The President executes a player. From now on the Chancellor may propose a veto.",
};
const WIN: TrackSlot = { title: "Fascists win", text: "The sixth Fascist policy ends the game." };

export function rulesFor(playerCount: number): TableRules {
  const fascists = playerCount <= 6 ? 1 : playerCount <= 8 ? 2 : 3;
  const liberals = playerCount - fascists - 1;
  let track: TrackSlot[];
  if (playerCount <= 6) {
    track = [NONE, NONE, PEEK, EXECUTE, EXECUTE_VETO, WIN];
  } else if (playerCount <= 8) {
    track = [NONE, INVESTIGATE, SPECIAL, EXECUTE, EXECUTE_VETO, WIN];
  } else {
    track = [INVESTIGATE, INVESTIGATE, SPECIAL, EXECUTE, EXECUTE_VETO, WIN];
  }
  return { liberals, fascists, hitlerKnowsFascists: playerCount <= 6, track };
}
